import { render } from "./TheSideNavBar.vue?vue&type=template&id=f7d4b594&ts=true"
import script from "./TheSideNavBar.vue?vue&type=script&lang=ts"
export * from "./TheSideNavBar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__